export default __webpack_public_path__ + "static/treneri-jaroslav-suchy-0f73e4cc31fe68d54f79871019a465f9.jpg";